export const GLOBAL_STATE_NAME = {
  SETTINGS: 'globalSettings',
  ALERT: 'globalAlert',
}

export const EULA_KEY = 'sst_blue_print_eula_accepted'
export const LOADING = {
  FAILED: 'failed',
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  REJECTED: 'rejected',
}

export const TOP_NAVIGATION_MODAL = {
  EULA: 'eula',
  SETTINGS: 'settings',
  ABOUT: 'about',
  UPLOAD: 'upload',
  FEEDBACK: 'feedback',
  ADD_TO_HOME_SCREEN: 'addToHomeScreen',
}

export const UI_INITIAL_STATE = {
  ecMode: false,
}

export const CALCULATION_ACTION = {
  MODIFY: 'modifyCalculation',
  UPDATE: 'updateCalculation',
}

export const APP_TOKEN_KEY = 'sst_bp_token'

export const PANE_HEADER = {
  '2D': '2D Viewer',
  '3D': '3D Viewer',
  INPUT: 'Input',
  OUTPUT: 'Output',
  JOB_TALLY: 'Job Tally',
}

export const IJOIST_INPUT_TYPE = {
  LEGACY_MANUFACTURER: 0,
  LEGACY_MANUALLY: 1,
  MANUFACTURER: 'manufacturer',
  MANUALLY: 'manually',
}

export const IJOIST_INPUT_OPTIONS = [
  {
    value: IJOIST_INPUT_TYPE.MANUFACTURER,
    text: 'Yes',
  },
  {
    value: IJOIST_INPUT_TYPE.MANUALLY,
    text: 'No',
  },
]

export const MEMBER_MANUFACTURER_PRODUCTS = {
  JOIST: 'Joist',
  RAFTER: 'Rafter',
}

export const MESH_MATERIALS = {
  TRUSS: 'truss',
  STUD: 'truss',
  SOLID_SAWN: 'solidSawn',
  GLULAM: 'glulam',
  LAMINATED_STRAND_LUMBER: 'lsl',
  LAMINATED_VENEER_LUMBER: 'lvl',
  PARALLEL_STRAND_LUMBER: 'psl',
  IJOIST: 'ijoist',
  FLOOR_TRUSS: 'floorTruss',
  MASONRY: 'masonry',
  MASONRY_MID_WALL: 'masonryMidWall',
  MASONRY_TOP_WALL: 'masonryTopWall',
  LEDGER: 'ledger',
  CONCRETE: 'concrete',
  STRUCTURE_STEEL: 'ssteel',
  STEEL: 'steel',
  NAILER: 'nailer',
  WALL_SHEATED_FLUSH: 'wallSFlush',
  WALL_SHEATED_GAP: 'wallSGap',
  WALL_DRYWALL_FLUSH: 'wallDFlush',
  WALL_DRYWALL_GAP: 'wallDGap',
  WALL_DRYWALL_FLUSH_STUD: 'wallDFlusStud',
}

export const MESH_PLY = {
  SINGLE: 1,
  DOUBLE: 2,
  TRIPLE: 3,
  QUAD: 4,
  PEN: 5,
}

export const MULTIPART_FORM_CONFIG = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  },
  timeout: 120000, // Increase timeout to handle large files upload
}

export const COUNTRY = {
  USA: 'usa',
  CANADA: 'canada',
}

export const COUNTRY_LABELS = {
  [COUNTRY.USA]: 'USA',
  [COUNTRY.CANADA]: 'Canada',
}

export const SECTION_PANEL = {
  INPUT: 'inputSection',
  OUTPUT: 'outputSection',
  ILLUSTRATION: 'illustrationSection',
}

export const MOBILE_NAVIGATION_BTN = [
  {
    label: 'Input',
    value: SECTION_PANEL.INPUT,
  },
  { label: 'Output', value: SECTION_PANEL.OUTPUT },
  { label: '3D View', value: SECTION_PANEL.ILLUSTRATION },
]

export const MEASURE_UNITS = {
  FT: 'ft',
  INCH: 'in.',
}

export const GLOBAL_SETTINGS_FONTSIZE_VALUES = {
  DEFAULT: '-densityDefault',
  EXPANDED: '-densityExpanded',
  COMPACT: '-densityCompact',
  STANDARD: '-densityStandard',
}

export const GLOBAL_SETTINGS_FONTSIZE_OPTIONS = [
  {
    label: 'Standard',
    value: GLOBAL_SETTINGS_FONTSIZE_VALUES.STANDARD,
  },
  {
    label: 'Expanded',
    value: GLOBAL_SETTINGS_FONTSIZE_VALUES.EXPANDED,
  },
]

export const GLOBAL_SETTINGS_ORIENTATION_VALUES = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
}

export const GLOBAL_SETTINGS_ORIENTATION_OPTIONS = [
  {
    label: 'Vertical',
    value: GLOBAL_SETTINGS_ORIENTATION_VALUES.VERTICAL,
  },
  {
    label: 'Horizontal',
    value: GLOBAL_SETTINGS_ORIENTATION_VALUES.HORIZONTAL,
  },
]

export const DEFAULT_GLOBAL_SETTINGS_STATE = {
  isEulaAccepted: false,
  orientation: GLOBAL_SETTINGS_ORIENTATION_VALUES.HORIZONTAL,
  fontSize: GLOBAL_SETTINGS_FONTSIZE_VALUES.STANDARD,
  mediaClass: '-media-md',
  theme: '-themeLight',
  mobileNav: false,
}

export const DEFAULT_GLOBAL_ALERT_STATE = {
  level: '',
  title: '',
  description: '',
}

export const OPTIMIZED_MODELS_LENGTH = 10
export const NOT_AVAIABLE_VALUE = 'N/A'

export const DEFAULT_PRODUCT_ORIGIN_URL = 'https://strongtie.com'

export const MSG_LEVEL = {
  ERROR: 'error',
  WARNING: 'warning',
}

export const EULA_ACCEPTED_DAY = 'eulaAcceptedDay'
